import React from 'react'
import styled from 'styled-components'
import { Button } from 'spa/member/components/Button'
import JobOffersModal from 'spa/member/components/JobOffersModal'

export type QuerySelectModalProps = {
  modalTitle: string,
  children: React.ReactNode,
  count: number,
  dataCy?: string,
  onClose: () => void,
  onSubmit: () => void,
}

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 72vh;

  @media ${props => props.theme.media.sm} {
    height: 584px;
  }
`

const StyledContent = styled.div`
  overflow: auto;
  height: 100%;
`

const StyledModalFooter = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin: auto auto 0;
  text-align: center;
  align-items: center;
  padding: 20px 20px 30px;
  width: 100%;
  height: auto;
  background-color: ${props => props.theme.members.colors.white};
  border-top: 1px solid ${props => props.theme.members.colors.silver._30};
  box-shadow: 0px -10px 20px 0px #0000000D;
`

const StyledButtonContainer = styled.div`
  width: 17rem;
  align-items: center;
`

const StyledCountText = styled.div`
  font-size: .75rem;
  font-weight: 700;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  > span {
    font-size: 1.5rem;
    margin: auto .25rem;
  }
`

const StyledButton = styled(Button)`
  margin-bottom: 12px;
  background-color: ${props => props.theme.members.colors.orange._80};
  color: ${props => props.theme.members.colors.white};
`

const StyledLinkButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  color: ${props => props.theme.members.colors.silver._70};
  font-size: .75rem;
  font-weight: 700;
`

export const StyledJobOffersQuerySelectModal: React.FC<QuerySelectModalProps> = (props: QuerySelectModalProps) => {
  return (
    <JobOffersModal modalTitle={props.modalTitle} onClose={props.onClose} dataCy={props.dataCy}>
      <StyledContainer>
        <StyledContent>
          {props.children}
        </StyledContent>
        <StyledModalFooter>
          <StyledButtonContainer>
            <StyledCountText>該当するお仕事数<span>{props.count}</span>件</StyledCountText>
            <StyledButton type='button' onClick={props.onSubmit}>設定する</StyledButton>
            <StyledLinkButton type='button' onClick={props.onClose}>キャンセル</StyledLinkButton>
          </StyledButtonContainer>
        </StyledModalFooter>
      </StyledContainer>
    </JobOffersModal>
  )
}
